import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
    selector: "love-it-number-range",
    templateUrl: "./number-range.component.html",
    styleUrls: ["./number-range.component.scss"],
    standalone: false
})
export class NumberRangeComponent implements OnInit {
  /***
   * Must include
   *  - from (formControl)
   *  - to (formControl)
   */
  @Input() formGroup: FormGroup;
  @Input() placeholderFrom: string = "";
  @Input() placeholderTo: string = "";

  constructor() {}

  ngOnInit(): void {}

  get fromControl(): FormControl {
    return this.formGroup.get("from") as FormControl;
  }

  get toControl(): FormControl {
    return this.formGroup.get("to") as FormControl;
  }
}
